export const MARKERERROR = 'MARKERERROR'